import React, {useEffect, useRef, useState} from 'react';
import {useFieldArray} from 'react-hook-form';
import Input from '../global/Input';
import {Button} from 'primereact/button';
import {useGetKontaktTypesQuery} from '../../redux/rtk/injectedPersonApi';
import {CustomConfirmDialog} from '../global/CustomConfirmDialog';
import {TabPanel, TabView} from 'primereact/tabview';
import {classNames} from 'primereact/utils';

type AddressProps = {
    projectId: string,
    t: any,
    getFormErrorMessage: (name: string) => void,
    form: any,
    edit: boolean,
}

export const BankForm = (props: AddressProps) => {
    const t = props.t;

    const [activeTabIndex, setActiveTabIndex] = useState<number>(0);
    const [bankName, setBankName] = useState<string>('');

    const {control, formState: {errors}, handleSubmit, setValue, getValues, watch} = props.form;

    const id = 'bank';

    const {fields, append, prepend, remove, swap, move, insert} = useFieldArray({
        control, // control props comes from useForm (optional: if you are using FormContext)
        name: id, // unique name for your Field Array
    });

    const getBankData = (item: any, index: number) => {

        return (
            <div className={'grid mt-3'}>
                <div className={'col-8'}>
                    <Input
                        edit={props.edit} label={t('globalData:persons.bankname')}
                        name={`${id}.${index}.name`}
                        validationControl={control}
                        validationErrorMessage={props.getFormErrorMessage}
                        validationRules={{required: false}}
                    />
                </div>
                <div className={'col-4'}>
                    {props.edit &&
                    <Button className={'p-button-rounded p-button-danger p-button-text mt-auto'}
                            style={{float: 'right'}}
                            type={'button'}
                            icon={'pi pi-trash'}
                            disabled={!props.edit}
                            onClick={() => {
                                CustomConfirmDialog({
                                    message: t('globalData:dialogs.deleteBank'),
                                    header: t('confirmDialog:deleteDialogHeader'),
                                    translation: t,
                                    onConfirm: () => {
                                        remove(index);
                                        setActiveTabIndex(0);
                                    }
                                });
                            }}/>}
                </div>
                <div className={'col-12'}>
                    <Input
                        edit={props.edit} label={t('globalData:persons.sap_kreditoren_nummer')}
                        name={`${id}.${index}.sap_kreditoren_nummer`}
                        validationControl={control}
                        validationErrorMessage={props.getFormErrorMessage}
                        validationRules={{required: false}}
                    />
                </div>
                <div className={'col-12'}>
                    <Input
                        edit={props.edit} label={t('globalData:persons.iban')}
                        name={`${id}.${index}.iban`}
                        validationControl={control}
                        validationErrorMessage={props.getFormErrorMessage}
                        validationRules={{required: false}}
                    />
                </div>
                <div className={'col-6'}>
                    <Input
                        edit={props.edit} label={t('globalData:persons.bank')}
                        name={`${id}.${index}.bank`}
                        validationControl={control}
                        validationErrorMessage={props.getFormErrorMessage}
                        validationRules={{required: false}}
                    />
                </div>
                <div className={'col-6'}>
                    <Input
                        edit={props.edit} label={t('globalData:persons.bic')} name={`${id}.${index}.bic`}
                        validationControl={control}
                        validationErrorMessage={props.getFormErrorMessage}
                        validationRules={{required: false}}
                    />
                </div>
                <div className={'col-6'}>
                    <Input
                        edit={props.edit} label={t('globalData:persons.bank_land')} name={`${id}.${index}.bank_land`}
                        validationControl={control}
                        validationErrorMessage={props.getFormErrorMessage}
                        validationRules={{required: false}}
                    />
                </div>
                <div className={'col-6'}>
                    <Input
                        edit={props.edit} label={t('globalData:persons.swift')} name={`${id}.${index}.swift`}
                        validationControl={control}
                        validationErrorMessage={props.getFormErrorMessage}
                        validationRules={{required: false}}
                    />
                </div>
            </div>
        );
    };

    return (
        <div className={'relative'} style={{minHeight: '30px'}}>
            {props.edit &&
            <div className={'grid grid-nogutter '}>
                <div className={'col-6'}>
                    <Input
                        edit={props.edit} label={t('globalData:persons.bankname')}
                        name={`bankname`}
                        value={bankName}
                        onChange={(e: any) => {
                            setBankName(e.target.value);
                        }}
                    />
                </div>
                <div className={'col-6'}>
                    <div className={'relative w-full h-full flex'}>
                        <Button
                            disabled={!bankName}
                            className={'p-button-success p-button-outlined p-button-icon-only absolute'}
                            style={{left: '0', bottom: '0'}}
                            type={'button'} icon={'pi pi-plus'} onClick={() => {
                            append({
                                'iban': '',
                                'bic': '',
                                'bank': '',
                                'bank_land': '',
                                'swift': '',
                                'sap_kreditoren_nummer': '',
                                'name': bankName
                            });
                            setBankName('');
                        }}/>
                    </div>
                </div>
            </div>}
            {fields.length > 0 && <TabView activeIndex={activeTabIndex} onTabChange={(e: any) => {
                setActiveTabIndex(e.index);
            }}>
                {fields.map((field, index) => {
                    return (<TabPanel key={index} header={getValues(`${id}.${index}.name`)}>
                        {getBankData(field, index)}
                    </TabPanel>);
                })}
            </TabView>}
        </div>
    );
};
;
